import type { KeyIndicator } from "../pdf/types"
import { DOMAIN_LABELS } from "../sharedTokens"
import { MeasuredPaginator, type PaginatorItem } from "./MeasuredPaginator"
import { DomainHeaderAndBullets, DomainMetricTable, HeaderBar, HeaderText, PageCard, PageContent } from "./shared"

interface Props {
  domains: string[]
  indicatorsByDomain: Record<string, KeyIndicator[]>
}

export function SystemConditionPaginator({ domains, indicatorsByDomain }: Props) {
  const items: PaginatorItem[] = []
  for (const domain of domains) {
    const indicators = indicatorsByDomain[domain]
    if (!indicators) continue
    items.push({
      id: `${domain}-content`,
      node: <DomainHeaderAndBullets title={DOMAIN_LABELS[domain]} indicators={indicators} />,
    })
    items.push({
      id: `${domain}-table`,
      node: <DomainMetricTable indicators={indicators} />,
    })
  }

  return (
    <MeasuredPaginator
      items={items}
      renderPage={(nodes, idx) => (
        <PageCard key={idx}>
          <HeaderBar>
            <HeaderText>System Condition</HeaderText>
          </HeaderBar>
          <PageContent>{nodes}</PageContent>
        </PageCard>
      )}
    />
  )
}
